// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";

export type SearchType = {
  id: string,
  query: string,
  secondsElapsed: number
};

const createSearchMutation = gql`
  mutation($query: String!, $secondsElapsed: Float!) {
    createSearch(query: $query, secondsElapsed: $secondsElapsed) {
      id
      query
      secondsElapsed
    }
  }
`;

export const withCreateSearch = graphql(createSearchMutation, {
  name: "createSearch"
});

export type createSearchMutationResult = {
  data: {
    createSearch: SearchType
  }
};

export type createSearchType = ({
  variables: { query: string, secondsElapsed: number }
}) => Promise<createSearchMutationResult>;



// WEBPACK FOOTER //
// ./src/data/search.js